var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 13.333.471.471-.471.472-.471-.472zm-.667-10a.667.667 0 1 1 1.334 0H7.333m4.667 6 .471.471-4 4L8 13.333l-.471-.471 4-4zm-4 4-.471.471-4-4L4 9.333l.471-.471 4 4zm0 0h-.667v-10h1.334v10z"
  })));
};
export default SvgArrowDown;